<template>
<div class="sidebar main-sidebar">
	<h1>Explore Mines & Hydrocarbons</h1>
	<grid flat class="tabs-caption">
		<grid-item size="1/2">
			<h3 class="pos-left" :class="activeTab == 0 ? 'active' : ''" @click="activeTab = 0">Opportunities</h3>
		</grid-item>
		<grid-item size="1/2">
			<h3 class="pos-right" :class="activeTab == 1 ? 'active' : ''" @click="activeTab = 1">Companies</h3>
		</grid-item>
	</grid>
	<grid flat class="tabs-content" v-if="activeTab == 0">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Oil & Gas Licensing Round"
				:itemList="oilLicList"
				v-model="selectedOilLic"
			/>
			<custom-multiple-select
				label="Mining Licensing Round"
				:itemList="miningList"
				v-model="selectedMining"
			/>
			<custom-multiple-select
				label="Oil & Gas Farm-in"
				:itemList="oilList"
				v-model="selectedOil"
			/>
			<hr>
			<button class="button primary" @click="search()">View on map</button>
		</grid-item>
	</grid>
	<grid class="tabs-content" v-if="activeTab == 1">
		<grid-item size="1/1">
			<custom-multiple-select
				label="Oil & Gas Licensing Round"
				:itemList="oilLicList"
				v-model="selectedOilLic"
			/>
			<custom-multiple-select
				label="Mining Licensing Round"
				:itemList="miningList"
				v-model="selectedMining"
			/>
			<custom-multiple-select
				label="Oil & Gas Farm-in"
				:itemList="oilList"
				v-model="selectedOil"
			/>
			<hr>
			<button class="button primary" @click="search()">View on map</button>
		</grid-item>
	</grid>
</div>
</template>

<script>
import CustomMultipleSelect from '@/components/secondary/CustomMultipleSelect'
import { mapActions, mapState } from 'vuex'

export default {
	components: {
		CustomMultipleSelect
	},
	data: () => ({
		activeTab: 0,
		oilLicList: [],
		selectedOilLic: [],
		miningList: [],
		selectedMining: [],
		oilList: [],
		selectedOil: []
	}),
	methods: {
		search() {
			this.$router.push({
				name: 'opportunity-list',
				query: {
					...this.$route.query,
					sectorId: [27, 28, 29, 30]
				}
			})
		}
	}
}
</script>

<style lang="scss">
</style>
